import ModalAddFavorite from './views/ModalAddFavorite';
import ModalDatePicker from './views/ModalDatePicker';
import ModalDefault from './views/ModalDefault';
import ModalDeleteConfirm from './views/ModalDeleteConfirm';
import ModalExercise from './views/ModalExercise';
import ModalExerciseManager from './views/ModalExerciseManager';
import ModalFoodItemNutrition from './views/ModalFoodItemNutrition';
import ModalMealEditor from './views/ModalMealEditor';
import ModalMealNutrition from './views/ModalMealNutrition';
import ModalOwnExercise from './views/ModalOwnExercise';
import ModalOwnMeal from './views/ModalOwnMeal';
import ModalRecipeServings from './views/ModalRecipeServings';

/**
 * Holds all modal views.
 * Each view is a function that receives props and returns JSX.
 */

export const MODAL_VIEWS = {
    default: ModalDefault,
    ownMeal: ModalOwnMeal,
    editMeal: ModalMealEditor,
    nutrition: ModalMealNutrition,
    itemNutrition: ModalFoodItemNutrition,
    datePicker: ModalDatePicker,
    exercise: ModalExercise,
    ownExercise: ModalOwnExercise,
    deleteMeal: ModalDeleteConfirm,
    deleteExercise: ModalDeleteConfirm,
    favorite: ModalAddFavorite,
    editExercise: ModalExerciseManager,
    recipeServings: ModalRecipeServings
};
